import { type Socio } from './interfaces/socio.interface';

export const MOCK_SOCIOS: Socio[] = [
	{
		id: '9',
		nAsiento: 5,
		fecha: '25/11/2020',
		titular: 'MIGUEL ANGEL GARCIA MUNGUIA',
		nDocumento: '46629207L',
		participacion: 750,
		numeracion: '1501-2250',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio: 'CL MAS JANER nº43, 08197 Sant Cugat del Vallès',
	},
	{
		id: '10',
		nAsiento: 6,
		fecha: '25/11/2020',
		titular: 'MARC ANTON PONS',
		nDocumento: '46963023J',
		participacion: 750,
		numeracion: '751-1500',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio:'CL Sugranyes nº39, 08028 Barcelona',
	},
	{
		id: '11',
		nAsiento: 7,
		fecha: '25/11/2020',
		titular: 'MICHAEL KORN',
		nDocumento: 'X1216788L',
		participacion: 750,
		numeracion: '1-750',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio: 'CL Bonavista nº107, 08008 Barcelona',
	},
	{
		id: '12',
		nAsiento: 8,
		fecha: '25/11/2020',
		titular: 'DANIEL ALEJANDRO POLO MOROS',
		nDocumento: '32713183F',
		participacion: 750,
		numeracion: '2251-3000',
		titulo: 'Titularidad resultante tras venta',
		domicilio: 'CL TUI nº24, 15570 Narón',
	}
];

export const MOCK_SOCIOS_ARCHIVE: Socio[] = [
	{
		id: '1',
		nAsiento: 1,
		fecha: '14/02/2020',
		titular: 'SOCIETALIS, S.L.',
		nDocumento: 'B64384209',
		participacion: 2999,
		numeracion: '1-2999',
		titulo: 'CONSTITUCIÓN DE SOCIEDAD LIMITADA',
		domicilio: 'CL MARQUES DE MULHACEN nº8, 08034 Barcelona',
	},
	{
		id: '2',
		nAsiento: 2,
		fecha: '14/02/2020',
		titular: 'IGNACIO MANUEL MORENO AMATRIAIN',
		nDocumento: '46759179H',
		participacion: 1,
		numeracion: '3000',
		titulo: 'CONSTITUCIÓN DE SOCIEDAD LIMITADA',
		domicilio: 'CL MARQUES DE MULHACEN nº8, 08034 Barcelona',
	},
	{
		id: '3',
		nAsiento: 3,
		fecha: '09/06/2020',
		titular: 'DANIEL ALEJANDRO POLO MOROS',
		nDocumento: '32713183F',
		participacion: 2999,
		numeracion: '1-2999',
		titulo: 'Compra a SOCIETALIS, S.L.',
		domicilio: 'CL CAMP DEL FERRO nº3, 08027 Barcelona',
	},
	{
		id: '4',
		nAsiento: 4,
		fecha: '09/06/2020',
		titular: 'DANIEL ALEJANDRO POLO MOROS',
		nDocumento: '32713183F',
		participacion: 3000,
		numeracion: '1-3000',
		titulo: 'Compra a IGNACIO MANUEL MORENO AMATRIAIN',
		domicilio: 'CL CAMP DEL FERRO nº3, 08027 Barcelona',
	},
	{
		id: '5',
		nAsiento: 5,
		fecha: '25/11/2020',
		titular: 'MIGUEL ANGEL GARCIA MUNGUIA',
		nDocumento: '46629207L',
		participacion: 750,
		numeracion: '1501-2250',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio: 'CL MAS JANER nº43, 08197 Sant Cugat del Vallès',
	},
	{
		id: '6',
		nAsiento: 6,
		fecha: '25/11/2020',
		titular: 'MARC ANTON PONS',
		nDocumento: '46963023J',
		participacion: 750,
		numeracion: '751-1500',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio: 'CL Sugranyes nº39, 08028 Barcelona',
	},
	{
		id: '7',
		nAsiento: 7,
		fecha: '25/11/2020',
		titular: 'MICHAEL KORN',
		nDocumento: 'X1216788L',
		participacion: 750,
		numeracion: '1-750',
		titulo: 'Compra a DANIEL ALEJANDRO POLO  MOROS',
		domicilio: 'CL Bonavista nº107, 08008 Barcelona',
	},
	{
		id: '8',
		nAsiento: 8,
		fecha: '25/11/2020',
		titular: 'DANIEL ALEJANDRO POLO MOROS',
		nDocumento: '32713183F',
		participacion: 750,
		numeracion: '2251-3000',
		titulo: 'Titularidad resultante tras venta',
		domicilio: 'CL TUI nº24, 15570 Narón',
	}
];

export const MOCK_SOCIOS_AJENOS: Socio[] = [
	{
		id: '13',
		nAsiento: 6,
		fecha: '28/10/2025',
		titular: 'SALVADOR CAMARA MARTIN',
		nDocumento: '74840102B',
		participacion: 10000,
		numeracion: '1-1500, 11501-20000',
		titulo: 'AMPLIACIÓN DE CAPITAL CON SUSCRIPCIÓN',
	},
	{
		id: '14',
		nAsiento: 7,
		fecha: '28/10/2025',
		titular: 'RAMON RESA PALOMO',
		nDocumento: '51450526D',
		participacion: 10000,
		numeracion: '1501-11500',
		titulo: 'AMPLIACIÓN DE CAPITAL CON SUSCRIPCIÓN',
	}
];

export const MOCK_SOCIOS_ARCHIVE_AJENOS: Socio[] = [
	{
		id: '15',
		nAsiento: 1,
		fecha: '12/03/2019',
		titular: 'MIGUEL CUESTA ORTEGO',
		nDocumento: '50885195H',
		participacion: 30,
		numeracion: '2971-3000',
		titulo: 'CONSTITUCIÓN DE SOCIEDAD LIMITADA',
		domicilio: 'CL ARDEMANS nº68, 28028 Madrid',
	},
	{
		id: '16',
		nAsiento: 2,
		fecha: '12/03/2019',
		titular: 'RAMON RESA PALOMO',
		nDocumento: '51450526D',
		participacion: 2970,
		numeracion: '1-2970',
		titulo: 'CONSTITUCIÓN DE SOCIEDAD LIMITADA',
		domicilio: 'CL BUSTARVIEJO nº5, 28020 Madrid',
	},
	{
		id: '17',
		nAsiento: 3,
		fecha: '30/07/2019',
		titular: 'SALVADOR CAMARA MARTIN',
		nDocumento: '74840102B',
		participacion: 1470,
		numeracion: '1501-2970',
		titulo: 'Compra a RAMON RESA PALOMO',
		domicilio: 'AV ARCES nº17, 28042 Madrid',
	},
	{
		id: '18',
		nAsiento: 4,
		fecha: '30/07/2019',
		titular: 'RAMON RESA PALOMO',
		nDocumento: '51450526D',
		participacion: 1500,
		numeracion: '1-1500',
		titulo: 'Titularidad resultante tras venta',
		domicilio: 'CL BUSTARVIEJO nº5, 28020 Madrid',
	},
	{
		id: '19',
		nAsiento: 5,
		fecha: '30/07/2019',
		titular: 'SALVADOR CAMARA MARTIN',
		nDocumento: '74840102B',
		participacion: 1500,
		numeracion: '2971-3000',
		titulo: 'Compra a MIGUEL CUESTA ORTEGO',
		domicilio: 'AV ARCES nº17, 28042 Madrid',
	},
	{
		id: '20',
		nAsiento: 6,
		fecha: '28/10/2025',
		titular: 'RAMON RESA PALOMO',
		nDocumento: '51450526D',
		participacion: 10000,
		numeracion: '1-1500, 11501-20000',
		titulo: 'AMPLIACIÓN DE CAPITAL CON SUSCRIPCIÓN',
	},
	{
		id: '21',
		nAsiento: 7,
		fecha: '28/10/2025',
		titular: 'SALVADOR CAMARA MARTIN',
		nDocumento: '74840102B',
		participacion: 10000,
		numeracion: '1501-11500',
		titulo: 'AMPLIACIÓN DE CAPITAL CON SUSCRIPCIÓN',
	}
];